import { memo } from "react";
import { AspectRatio } from "../ui/aspect-ratio";
import { cn } from "@/lib/utils";

interface TutorialThumbnailProps {
  src?: string;
  alt: string;
  muted?: boolean;
}

const FALLBACK_IMAGE = "/fallback.svg";

export const TutorialThumbnail = memo(function TutorialThumbnail({
  src,
  alt,
  muted = false,
}: TutorialThumbnailProps) {
  return (
    <AspectRatio
      ratio={16 / 9}
      className={cn("bg-muted cursor-pointer", {
        "hover:cursor-not-allowed": muted,
      })}
    >
      <img
        src={src ?? FALLBACK_IMAGE}
        alt={alt}
        className={cn(
          "w-full h-full object-cover",
          "transition-transform duration-300 group-hover:scale-105"
        )}
        loading="lazy"
      />
    </AspectRatio>
  );
});
